const FORM_SECTION_MED_HIST_ID      = 'CaseFormMedicalHistorySection';
const FORM_SECTION_OB_SCORE_ID      = 'CaseFormOBScoreSection';
const FORM_SECTION_ADMISSION_ID     = 'CaseFormAdmissionSection';
const FORM_SECTION_PREG_DELIVERY_ID = 'CaseFormPregnancyDeliverySection';
const FORM_SECTION_COMORBID_ID      = 'CaseFormCoMorbidSection';
const FORM_SECTION_PROCEDURES_ID    = 'CaseFormProceduresSection';
const FORM_SECTION_OBPROCEDURES_ID    = 'CaseFormOBProceduresSection';
const FORM_SECTION_GYNE_ID          = 'CaseFormGyneSection';
const FORM_SECTION_MIGS_INFO_ID     = 'CaseFormMIGSInfoSection';
const FORM_SECTION_DISCHARGE_ID     = 'CaseFormDischargeSection';

export default {
  FORM_SECTION_MED_HIST_ID,
  FORM_SECTION_OB_SCORE_ID,
  FORM_SECTION_ADMISSION_ID,
  FORM_SECTION_PREG_DELIVERY_ID,
  FORM_SECTION_GYNE_ID,
  FORM_SECTION_MIGS_INFO_ID,
  FORM_SECTION_DISCHARGE_ID,
  FORM_SECTION_PROCEDURES_ID,
  FORM_SECTION_OBPROCEDURES_ID,
  FORM_SECTION_COMORBID_ID
}
